import { WebsitePage } from 'publisher/pages/website-page'

export const createPage = () => WebsitePage
